import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { BrokerService } from '@c4/core';

import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { Device } from '../../../common/interfaces/item.interface';
import { Command } from '../../../common/params/interfaces/command.interface';
import { Parameter } from '../../../common/params/interfaces/parameter.interface';
import { C4ValueType } from '../../../common/params/param-input.component';
import { SharedProgrammingService, CommandData } from '../../../common/services/shared-programming.service';
import { ProgrammingUtilsService as Util } from '../../../common/services/utils.service';

import { SimpleProgrammingContext } from '../quickstart-simple.service';
import { CommandTypes } from '../command-types/command-types';

@Component({
  templateUrl: './select-params.component.html',
  styleUrls: ['./select-params.component.less']
})
export class QSSimpleSelectParamsComponent extends BaseRoutingComponent {

  private _device: Observable<Device>;
  private _command: Observable<Command>;
  private _parameters: Parameter[];
  private _icon: Observable<string>;

  constructor(
    public router: Router,
    private _route: ActivatedRoute,
    protected store: Store<{
      simpleProgramming: SimpleProgrammingContext
    }>,
    private _broker: BrokerService,
    private _shared: SharedProgrammingService
  ) {
    super();

    const routeParams = <{ id: string, command: string }>Util.snapshot(this._route.params);

    this._command = Observable.fromPromise(this._broker.call({
      path: `/api/v1/items/commands`,
      queryString: {
        query: {
          command: routeParams.command,
          deviceId: parseInt(routeParams.id)
        }
      }
    }))
      .map((commands: Command[]) => commands[0])
      .share();

    this._device = this.store.select(s => s.simpleProgramming.devices)
      .filter(d => !!d)
      .map(devices => devices.find(device => device.id == parseInt(routeParams.id)));

    this._icon = this.store.select(s => s.simpleProgramming.devices)
      .filter(d => !!d)
      .map(devices => devices.find(device => device.id == parseInt(routeParams.id)))
      .map(device => CommandTypes.find(ct => ct.whitelist.some(wl => wl.proxy == device.proxy)).whitelist.find(wl => wl.proxy == device.proxy))
      .flatMap(whitelist => this._command.map(c => whitelist.commands.find(wc => wc.command == c.command)))
      .map(command => command.icon);

    this._command.subscribe(command => {
      this._parameters = command.params
    });
  }

  private _configured = (): boolean => {
    return (this._parameters || []).every(param => {
      return param.value != undefined || param._value != undefined;
    })
  }

  private _saveCommand = () => {
    if (!this._configured()) { return; }

    let params = this._parameters
      .filter(p => !!p)
      .map(p => {
        p._value = p._value || p.value;
        return p;
      });

    let command = Util.snapshot<Command>(this._command);

    let data: CommandData = {
      codeitemId: 0,
      deviceId: command.deviceId,
      command: command.command,
      beforeCodeItemId: 0,
      parentCodeItemId: 0,
      creator: '',
      type: 1,
      params: this._parameters.map(p => {
        return {
          name: p.name,
          value: p._value,
          display: p._display
        }
      })
    };

    this._shared.saveAction(data);
  }

  private _update = (param: Parameter, value: C4ValueType) => {
    let ix = this._parameters.findIndex(p => param.name == p.name && param.type == p.type);
    this._parameters[ix] = Object.assign({}, this._parameters[ix], {
      _display: value.display,
      _value: value.value
    });

    this._parameters = [...this._parameters];
  }

  private _identify = (param: Parameter) => param.name + param.type;
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/select-params/select-params.component.ts